export const STATE_NAME = 'app';

export const APP_START = 'APP_START';

export const GET_CONFIGS = 'GET_CONFIGS';
export const GET_CONFIGS_DONE = 'GET_CONFIGS_DONE';
export const GET_CONFIGS_FAILED = 'GET_CONFIGS_FAILED';

export const GET_MARKET_CONFIGS = 'GET_MARKET_CONFIGS';
export const GET_MARKET_CONFIGS_DONE = 'GET_MARKET_CONFIGS_DONE';
export const GET_MARKET_CONFIGS_FAILED = 'GET_MARKET_CONFIGS_FAILED';

export const GET_MARKET_NAME = 'GET_MARKET_NAME';
export const GET_MARKET_NAME_DONE = 'GET_MARKET_NAME_DONE';
export const GET_MARKET_NAME_FAILED = 'GET_MARKET_NAME_FAILED';

export const GET_GLOBAL_CONFIGS = 'GET_GLOBAL_CONFIGS';
export const GET_GLOBAL_CONFIGS_DONE = 'GET_GLOBAL_CONFIGS_DONE';
export const GET_GLOBAL_CONFIGS_FAILED = 'GET_GLOBAL_CONFIGS_FAILED';

export const SET_MARKET = 'SET_MARKET';
export const SET_REVIEW_MARKET = 'SET_REVIEW_MARKET';

export const FETCH_CONFIG_SEPRATELY = 'FETCH_CONFIG_SEPRATELY';

export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_REVIEW_MARKET_LANGUAGE = 'SET_REVIEW_MARKET_LANGUAGE';

export const SET_DATA_DIRTY = 'SET_DATA_DIRTY';
export const SET_DATA_NOT_DIRTY = 'SET_DATA_NOT_DIRTY';

export const SET_USER_IS_GLOBAL = 'SET_USER_IS_GLOBAL';
export const SET_USER_IS_SERVICE_OFFICE = 'SET_USER_IS_SERVICE_OFFICE';

export const VIEW_VISITED = 'APP_VIEW_VISITED';

export const MARKET_GLOBAL = 'IFS';
export const MARKET_GLOBAL_LANG = 'EN-IF';

export const SAVE_AND_CALLBACK = 'SAVE_AND_CALLBACK';
